import { db } from "@/firebase/init.js";
import {
  collection,
  query,
  getDocs,
  getDoc,
  setDoc,
  deleteDoc,
  updateDoc,
  doc,
  orderBy,
} from "firebase/firestore"; // Create, Add Collection

const lessonsModule = {
  namespaced: true, // automatically added
  state: {
    lessonsList: [],
    isLoading: true,
    contents: [],
    isFirstLoad: true,
    isUpdateFirstLoad: true,
    updateLesson: {},
    lesson: {},
  },
  getters: {
    getLessons: (state) => state.lessonsList,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
    getContents: (state) => state.contents,
    getUpdatedLoad: (state) => state.isUpdateFirstLoad,
    getUpdateLesson: (state) => state.updateLesson,
    getLesson: (state) => state.lesson,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },
    // Lessons
    //// Get All Lessons
    setLessons: (state, payload) => {
      state.lessonsList = payload;
    },
    //// Add Lesson
    addLesson: (state, payload) => {
      if (state.lessonsList.length > 0) state.lessonsList.unshift(payload);
      else state.lessonsList = [payload];
    },
    //// Delete Lesson
    deleteLesson: (state, payload) => {
      let filtered = state.lessonsList.filter(function (value) {
        return value.lesson_id != payload;
      });
      state.lessonsList = filtered;
    },
    // get Lesson by id
    setLessonById: (state, payload) => {
      state.updateLesson = payload;
    },

    // Update Lesson
    updateLesson: (state, payload) => {
      const findIndex = state.lessonsList.findIndex(
        (lesson) => lesson.lesson_id == payload.lesson_id
      );
      state.lessonsList[findIndex] = payload;
    },

    // Contents
    // Add File in contents in LessonList
    addFile: (state, payload) => {
      state.lessonsList[payload.index].contents.push(payload);
    },

    // Add Question to exam in Lesson
    addQuestionToExam: (state, payload) => {
      state.lessonsList.contents.questions.push(payload.question);
    },

    // Save Exams to use in Lesson
    // Add Content
    addContents: (state, payload) => {
      if (state.contents.length > 0) state.contents.unshift(payload);
      else state.contents = [payload];
    },
    // Save lesson
    saveLesson: (state, payload) => {
      state.lesson = payload;
    },

    // Clear State
    clearStateStorage: (state) => {
      state.lesson = {};
      state.contents = [];
      state.isUpdateFirstLoad = true;
    },

    //
    // Update File
    updateFile: (state, payload) => {
      const findIndex = state.contents.findIndex(
        (file) => file.id == payload.id
      );
      state.contents[findIndex] = payload;
    },

    // Delete Mutitions
    // Delete File
    deleteFile: (state, payload) => {
      let filtered = state.contents.filter(function (value) {
        return value.id != payload;
      });
      state.contents = filtered;
    },
    // Delete Exam
    deleteExam: (state, payload) => {
      state.contents.splice(payload, 1);
    },

    // On Edit Page
    onEditEditSelectExam: (state, payload) => {
      const findIndex = state.updateLesson.contents.findIndex(
        (exam) => exam.title == payload.title
      );
      console.log("from Module:", state.updateLesson.contents[findIndex]);
      state.updateLesson.contents[findIndex] = payload;
    },
    onEditEditSelectVideo: (state, payload) => {
      const findIndex = state.updateLesson.contents.findIndex(
        (video) => video.id == payload.id
      );
      state.updateLesson.contents[findIndex] = payload;
      console.log("module", findIndex);
      console.log("mutation", payload);
    },

    setUpdateLoad: (state, payload) => {
      state.isUpdateFirstLoad = payload;
    },

    // Delete Mutitions
    // Delete File
    onEditDeleteFile: (state, payload) => {
      let filtered = state.updateLesson.contents.filter(function (value) {
        return value.id != payload;
      });
      state.updateLesson.contents = filtered;
    },
    // Delete Exam
    onEditDeleteExam: (state, payload) => {
      state.updateLesson.contents.splice(payload, 1);
    },
  },
  actions: {
    // Get All Lessons
    async fetchLessons({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);

      const lessonsList = await getDocs(
        query(collection(db, "Lessons"), orderBy("created_date", "desc"))
      );
      let lessonsArray = [];
      if (!lessonsList.empty) {
        lessonsList.forEach((doc) => {
          lessonsArray.push({ ...doc.data(), lesson_id: doc.id });
        });
      } else {
        console.log("No Lessons found");
        lessonsArray = false;
      }
      commit("setLessons", lessonsArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);

      return lessonsArray;
    },

    // // add Empty Lesson
    // async addEmptyLesson({ commit }, payload) {
    //   commit("setLoading", true);
    //   const documentReference = doc(collection(db, "Lessons"));

    //   const lesson = {
    //     ...payload,
    //     lesson_id: documentReference.id,
    //     created_date: new Date(),
    //   };
    //   setDoc(documentReference, lesson);
    //   commit("addLesson", lesson);
    //   commit("setLoading", false);
    //   localStorage.setItem("lesson_id", lesson.lesson_id);
    // },

    // async addFileToLesson({ commit }, payload) {
    //   commit("setLoading", true);

    //   let id = localStorage.getItem("lesson_id");
    //   const documentReference = doc(db, "Lessons", id);
    //   await setDoc(
    //     documentReference,
    //     {
    //       contents: arrayUnion({ ...payload, file_id: documentReference.id }),
    //     },
    //     { merge: true }
    //   );
    //   commit("addFile", false);
    //   commit("setLoading", false);
    // },
    // // Delete File in Contents in LessonList
    // async deleteFile({ commit }, payload) {
    //   commit("setLoading", true);
    //   let id = localStorage.getItem("lesson_id");
    //   const documentReference = doc(db, "Lessons", id);

    //   await deleteDoc(
    //     documentReference,
    //     {
    //       contents: arrayRemove({ payload }),
    //     },
    //     { merge: true }
    //   );
    //   commit("setLoading", false);
    // },

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    // add Lesson
    async addLesson({ commit }, payload) {
      const documentReference = doc(collection(db, "Lessons"));
      const lesson = {
        ...payload,
        lesson_id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, lesson);
      commit("addLesson", lesson);
    },
    // Get Lesson by Id
    async getLessonById({ commit }, payload) {
      commit("setLoading", true);
      commit("setUpdateLoad", true);
      let lesson = await getDoc(doc(db, "Lessons", payload));
      commit("setLessonById", lesson.data());
      commit("setUpdateLoad", false);
      commit("setLoading", false);
    },
    // Update Lesson
    async updateLessonById({ commit }, payload) {
      updateDoc(doc(db, "Lessons", payload.lesson_id), payload);
      commit("updateLesson", payload);
    },
    // Delete Lesson
    async deleteLesson({ commit }, payload) {
      deleteDoc(doc(db, "Lessons", payload));
      commit("deleteLesson", payload);
    },
    // Add File to Content
    addInContent({ commit }, payload) {
      commit("addContents", payload);
    },
    // Save Lesson information
    saveLessonData({ commit }, payload) {
      commit("saveLesson", payload);
    },

    // clear state Contents
    clearState({ commit }) {
      commit("clearStateStorage");
    },

    // Add Contents
    // Add file to Collection Files and save in Contents
    async addFile({ commit }, payload) {
      const documentReference = doc(collection(db, "Files"));
      const file = {
        ...payload,
        id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, file);
      commit("addContents", file);
    },

    // Add video to Collection Videos and save in Contents
    async addVideo({ commit }, payload) {
      const documentReference = doc(collection(db, "Videos"));
      const video = {
        ...payload,
        id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, video);
      commit("addContents", video);
    },

        async addExam({ commit }, payload) {
      const documentReference = doc(collection(db, "Exams"));
      const exam = {
        ...payload,
        id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, exam);
      commit("addContents", exam);
    },

    // Save Exam in Contents
    // async addExam({ commit }, payload) {
    //   commit("addContents", payload);
    // },

    // Getting Functions
    // Get By ID
    async getFileByID({ commit }, payload) {
      let file = await getDoc(doc(db, "Files", payload));
      commit("setLoading", false);
      return file.data();
    },
    async getVideoByID({ commit }, payload) {
      let video = await getDoc(doc(db, "Videos", payload));
      commit("setLoading", false);
      console.log(video.data());
      return video.data();
    },

        async getExamByID({ commit }, payload) {
      let exam = await getDoc(doc(db, "Exams", payload));
      commit("setLoading", false);
      console.log(exam.data());
      return exam.data();
    },

    // Update Functions
    // Update File
    async updateFileById({ commit }, payload) {
      updateDoc(doc(db, "Files", payload.id), payload);
      commit("updateFile", payload);
    },
    async updateVideoById({ commit }, payload) {
      updateDoc(doc(db, "Videos", payload.id), payload);
      commit("updateFile", payload);
    },
    async updateExamById({ commit }, payload) {
      updateDoc(doc(db, "Exams", payload.id), payload);
      commit("updateFile", payload);
    },
    // Delete Functions
    // Delete File
    async deleteFileByid({ commit }, payload) {
      deleteDoc(doc(db, "Files", payload));
      commit("deleteFile", payload);
    },
    async deleteVideoByid({ commit }, payload) {
      deleteDoc(doc(db, "Videos", payload));
      commit("deleteFile", payload);
    },
        async deleteExamByid({ commit }, payload) {
      deleteDoc(doc(db, "Exams", payload));
      commit("deleteFile", payload);
    },
    async deleteExamByIndex({ commit }, payload) {
      commit("deleteExam", payload);
    },

    // On Edit Page
    async onEditEditExam({ commit }, payload) {
      commit("onEditEditSelectExam", payload);
    },
    //
    async onEditEditVideo({ commit }, payload) {
      console.log("Modular", payload);
      commit("onEditEditSelectVideo", payload);
      updateDoc(doc(db, "Video", payload.id), payload);
    },

    // Delete Functions
    // Delete File
    async onEditDeleteFileByid({ commit }, payload) {
      deleteDoc(doc(db, "Files", payload));
      commit("onEditDeleteFile", payload);
    },
    async onEditDeleteVideoByid({ commit }, payload) {
      deleteDoc(doc(db, "Videos", payload));
      commit("onEditDeleteFile", payload);
    },
    async onEditDeleteExamByIndex({ commit }, payload) {
      commit("onEditDeleteExam", payload);
    },
  },
};

export default lessonsModule;
